import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PiArrowRight } from "react-icons/pi";
import { MiniDashboardBici } from './MiniDashboardBici';
import { MiniDashboardMoto } from './MiniDashboardMoto';

function Home() {
    const navigate = useNavigate();
    const roll = parseInt(localStorage.getItem('userRoll'));

    return (
        <div className="w-full flex flex-col gap-8 lg:gap-16 lg:p-16 lg:mb-16 items-center py-2" data-testid="home-container">
            {/* Banner publicitario ovalado con degradado púrpura */}
            <div className="w-full flex justify-center " data-testid="home-banner">
                <div className="w-4/5 lg:w-4/5 h-20 lg:h-36 rounded-3xl bg-gradient-to-t from-purple-300  to-purple-700 flex items-center justify-center shadow-lg transform hover:scale-[1.02] transition-transform" data-testid="home-banner-content">
                    <div className="text-center" data-testid="home-banner-text">
                        <p className="text-lg font-semibold text-white">Visita <a href="https://sojoj.com/" className="underline text-amber-500 hover:text-amber-200 transition-colors" data-testid="home-banner-link">sojoj.com</a> y descubre más.</p>
                    </div>
                </div>
            </div>

            {/* Textos de bienvenida */}
            <div className="w-4/5 flex flex-col lg:gap-4 gap-1 items-center text-center" data-testid="home-welcome-text">
                <h2 className="text-3xl font-semibold text-gray-800 md:text-4xl">Bienvenido a <span className="text-amber-600">Parqueo</span></h2>
                {roll === 2 && (
                    <p className=" text-sm text-gray-500 md:text-base">Por favor recuerde generar el código QR cada vez que ingrese y salga del parqueadero para que el vigilante valide sus datos.</p>
                )}
            </div>

            {/* Botón para generar QR */}
            {roll === 2 && (
                <div className="w-4/5 " data-testid="home-qr-button-container">
                    <button 
                        onClick={() => navigate('/qr-generator?autoGenerate=true')}
                        className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
                        data-testid="home-qr-button"
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-300 to-purple-700 transition-transform duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 bg-gradient-to-l from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out"></div>
                        <span className="z-10 flex items-center">
                            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"></path>
                            </svg>
                            Generar código QR
                        </span>
                        <PiArrowRight className="z-10 text-2xl" />
                    </button>
                </div>
            )}

            {/* Widget simplificado de estatus del parqueadero */}
            <div className="w-4/5 ">
                <div className="bg-white shadow-lg rounded-lg p-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4">Ocupación del Parqueadero</h3>
                    
                    <div className="flex flex-col md:flex-row gap-6">
                        {/* Panel de bicicletas */}
                        <div className="flex-1 flex items-center justify-between bg-gray-50 p-4 rounded-lg">
                            <div className="flex flex-col">
                                <h4 className="text-base font-medium text-gray-700">Bicicletas</h4>
                                <p className="text-xs text-gray-500">Ocupación actual</p>
                            </div>
                            <MiniDashboardBici />
                        </div>

                        {/* Panel de motos */}
                        <div className="flex-1 flex items-center justify-between bg-gray-50 p-4 rounded-lg">
                            <div className="flex flex-col">
                                <h4 className="text-base font-medium text-gray-700">Motocicletas</h4>
                                <p className="text-xs text-gray-500">Ocupación actual</p>
                            </div>
                            <MiniDashboardMoto />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { Home };
